<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->

<div [class]="getMenuClasses()">
  @for (action of actions(); track action.id) {
    <button
      class="menu-item"
      [class.menu-item--disabled]="action.disabled"
      [attr.aria-label]="action.ariaLabel || action.tooltip"
      [disabled]="action.disabled"
      (click)="handleActionClick(action)"
      type="button">
      
      <!-- Tooltip with HoverTrigger -->
      <lfx-hover-trigger
        placement="auto"
        popoverClass="widget-menu-tooltip"
        cursor="pointer"
        [openDelay]="300"
        [closeDelay]="100">
        
        <!-- SVG Icon -->
        @if (hasSvgIcon(action)) {
          <img 
            [src]="action.svgIcon" 
            [alt]="action.tooltip" 
            class="menu-item__svg-icon">
        }
        
        <!-- FontAwesome Icon -->
        @if (hasIcon(action)) {
          <i [class]="action.icon"></i>
        }
        
        <!-- Popover Content (Tooltip Text) -->
        <div slot="popover-content">{{ action.tooltip }}</div>
      </lfx-hover-trigger>
    </button>
  }
</div>

